__turbopack_context__.v({
  "bar": "OverviewTopBarLoader-module__vCUf3q__bar",
  "topBar": "OverviewTopBarLoader-module__vCUf3q__topBar",
});
